import type { EntityCatalog } from './entity-catalog.types';
import { entityText } from './entity-text.util';

/** Catalog variant for the deleted-records tab (shows deleted_at, hides status column). */
export function buildDeletedCatalog(catalog: EntityCatalog): EntityCatalog {
  const statusKey = catalog.statusFieldKey ?? 'status';
  const hasDeletedAt = catalog.fields.some((field) => field.key === 'deleted_at');
  return {
    ...catalog,
    fields: [
      ...catalog.fields.map((field) => ({
        ...field,
        inList:
          field.key === 'deleted_at'
            ? true
            : !!field.inList && field.key !== statusKey,
      })),
      ...(hasDeletedAt
        ? []
        : [{ key: 'deleted_at', label: 'Deleted at', kind: 'text' as const, inList: true }]),
    ],
  };
}

export function formatDeletedAt(value: unknown): string {
  if (value == null || value === '') return '—';
  // entityText, not String(): the value is unknown, and a nested object would otherwise be shown
  // to the operator as the literal '[object Object]' when the date fails to parse.
  const text = entityText(value);
  const date = new Date(text);
  if (Number.isNaN(date.getTime())) return text || '—';
  return date.toLocaleString();
}
